import {
  alpha,
  Autocomplete,
  Box,
  Button,
  Modal,
  TextField,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { MdClose } from 'react-icons/md';

export const ModalStyled = styled(Modal)({
  display: 'flex',
  alignItems: 'center',
});

export const BoxModalStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  backgroundColor: theme.palette.global.white,
  padding: '1.6rem',
  borderRadius: 16,
  '@media (min-width: 1400px)': {
    padding: '1.6rem 8rem',
  },
}));

export const CloseModalStyled = styled(MdClose)(({ theme }) => ({
  position: 'fixed',
  right: 16,
  top: 16,
  '&:hover': {
    padding: 1,
    backgroundColor: alpha(theme.palette.secondary.main, 0.3),
    borderRadius: '50%',
    cursor: 'pointer',
  },
}));

export const ContainerInputsStyled = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  gap: 16,
  margin: '1rem 0',
  width: '90%',
});

export const TextFieldsStyled = styled(TextField)(() => ({
  width: '100%',
}));

export const CustomDivStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  border: '1px solid #c1c1c1',
  borderRadius: 6,
  minWidth: 400,
  '&:hover': {
    border: `1px solid ${theme.palette.global.gray}`,
  },
}));

export const CustomTitleStyled = styled('p')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  fontFamily: 'montserrat',
  paddingLeft: '.5rem',
  fontSize: 10,
  marginTop: -10,
  marginLeft: -225,
  backgroundColor: theme.palette.global.white,
  width: '9.5rem',
  color: theme.palette.global.lightgray,
}));

export const CustomInputDateStyled = styled('div')({
  '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
});

export const PeriodErrorStyled = styled('span')({
  fontFamily: 'montserrat',
  fontSize: 12,
  color: 'red',
});

export const CustomInputStyled = styled('input')(({ theme }) => ({
  border: 'none',
  borderRadius: 6,
  height: 48,
  width: 160,
  padding: 12,
  fontSize: 13,
  outline: 'none',
  fontFamily: 'montserrat',
  backgroundColor: theme.palette.global.white,
}));

export const AutocompleteInputsStyled = styled(TextField)(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    width: '12rem',
  },
  [theme.breakpoints.up('xl')]: {
    width: '18rem',
  },
}));

// TODO: o estilo abaixo é o mesmo estilo de cima porem com um componente diferente
// favor considerar refatorar.

export const AutocompleteInputsAutoCompleteComponentStyled = styled(
  Autocomplete
)(() => ({}));

export const ContainerButtonsStyled = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  gap: 16,
});

export const BtnDeleteFilterStyled = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.main,
  height: 38,
  width: 160,
  margin: '25px 0',
  fontWeight: 600,
  fontSize: 12,
}));

export const BtnFilterStyled = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.global.white,
  height: 38,
  width: 160,
  margin: '25px 0',
  fontWeight: 600,
  fontSize: 12,
}));
